export default "__VITE_ASSET__DJWFOPjJ__"